<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('introduction.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'introduction' }">{{ $t('introduction.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-card no-body>
        <b-tabs content-class="mt-3" pills card justified>
          <!-- <b-button
            squared
            block
            size="lg"
            variant="outline-primary"
            :to="{ name: 'memorial-ceremony-for-old-monk-jingkong' }"
          >
            本會創會董事長 <sup>上</sup>淨<sup>下</sup>空老和尚 圓寂兩週年追思紀念
          </b-button> -->
          <b-tab :title="$t('introduction.detail.history.title')" active>
<div v-if="$i18n.locale === 'tw'">
<p>一九八二年，一個殊勝的因緣下，簡豐文居士拜見了淨空法師，彼此之間談得很愉快。淨空法師說：「如果能找到一個合適的地點，做為弘揚佛法及培養講經人才的地方，這種功德是非常殊勝的。」簡居士聽了以後便說：「我剛好與一位地主黃昆追老先生談好一塊合建的土地，地點就在台北市杭州南路一段五十五號這個地方，不知適不適合做為弘揚佛法、培育人才的道場？」於是簡居士便與法師約定時間一起來察看杭州南路的這個地點。</p>
<p>看了之後，淨空法師說：「這個地方很好，交通也很方便，附近又有很多學校（台大法商學院就在對面、台北商專就在附近、台大醫學院也離此不遠）。這個地點很適合做為弘揚佛法、培養講經人才的道場。」</p>
<p>簡居士回去以後即開始草擬契約書，並約定時間正式與淨空法師簽定契約，彼此之間做個明確的承諾，從此確定了建立弘法利生，培養講經人才的地點。</p>
<p>一九八四年，大樓興建完成，隨即正式向教育部提出申請法人登記，由淨空法師取名為「財團法人佛陀教育基金會」。董事會推選淨空法師為董事長、簡豐文居士為總幹事。同年四月中旬，基金會在同一大樓的三樓成立了圖書館，命名為「華藏講堂」，於是開始對外服務。</p>
<p>基金會成立後，由於有三寶威德的加持、每位董事的護持與指導、以及信徒大眾的發心，會務才能逐漸推動。尤其有一群計程車司機朋友，他們都是淨空法師的常隨弟子，如呂國安、許秋雄、張燦祥等居士們，常常抽空到基金會來義務幫忙。在早期工作人員不足的情況下，有這麼多位居士的發心，是基金會成長中不可或缺的助緣。後來，有好幾位計程車師兄都出家了。</p>
<p>經過幾年的發展後，由於基金會逐漸受到十方緇素大德的肯定，工作量相對增加，原有簡居士獨自捐贈的場地就不敷使用了。於是由林國營與簡豐文等居士的發心，增購石牌書庫及本棟七樓教室、地下室教室等設施，讓基金會能提供更多服務。</p>
<p>一九九九年，鑑於電腦資訊化科技的逐漸發達，本會為達成不分國家地域、南傳北傳、顯教密教的差別，將佛陀的正法以電子資訊化的方式遍佈於世界各地，而開始進行網站架設的籌備工作。其中尤獲得康國泰等眾居士對本會網站的大力協助，使得本會的網站得於公元兩千年十二月一日與世界各地大眾結緣，功不可沒。</p>
<p>財團法人佛陀教育基金會從1984年成立到現在已經有幾十年的歷史了，雖然不算很長，但蒙三寶的威德加持、基金會全體同仁戰戰兢兢、不辭勞苦、不分晝夜地辛苦工作，以及廣大的三寶弟子、社會大眾同心協力共襄盛舉：有錢出錢，有力出力，不畏艱難，不分彼此，眾志成城，始有今日的小小成績。希望基金會能夠永續不斷地積極為協助弘揚佛法、利益眾生而努力，讓佛陀正法久住、法水長流。</p>
<p>2022年7月26日(農曆6月28日) 凌晨二時，本會創會董事長 <sup>上</sup>淨<sup>下</sup>空老和尚於台南極樂寺捨報圓寂，往生安養。</p>
<p>2022年9月30日本會召開第十三屆第五次董事會議，通過推選 釋密寶法師為繼任董事長。</p>
<p>2023年12月15日本會第十四屆董事會籌備會議，通過由 釋密寶法師擔任第十四屆董事會董事長。</p>
</div>
<div v-if="$i18n.locale === 'en'">
<p>In 1982, Venerable Chin-kung proposed establishing a foundation in central Taipei to propagate the Buddha Dharma. In response, an eminent layperson, who owned land in a central location, immediately offered space in the twelve-story building to be constructed there. As this land was near schools, government offices, and a large university hospital, in addition to being well served by public transport, Venerable Chin-kung concluded that it would be an ideal place for a Dharma resource foundation.</p>
<p>The building was complete two years later, and with a board of directors in place, and the foundation registered with the government, the Corporate Body of the Buddha Educational Foundation was ready to serve the public. The library opened on the 3rd floor in April of 1984.</p>
<p>The library proved very popular and the foundation's activities were soon expanded. At the time, staff numbers were insufficient to cope with the demand, but Dharma friends from all walks of life rallied round to ensure that the service the foundation was providing continued unabated.</p>
<p>After several years of continued growth, the original space became inadequate. A Dharma supporter consequently offered a warehouse in a Taipei suburb and also the 7th floor of the original building. The former serves as a storage area for the Dharma books that the foundation publishes for free distribution, while the latter is used as a lecture room for Dharma classes.</p>
<p>In 1999, drawing on the foundation's experience in printing Dharma material, it was decided to embrace the computer age and to offer Dharma teachings over the web. Adopting this media has greatly enhanced the foundation's ability to present the Dharma to the general public.</p>
</div>
            <div class="row">
              <div class="col-6">
                <b-img src="img/introduction/01.jpg" fluid></b-img>
              </div>
              <div class="col-6">
                <b-img src="img/introduction/02.jpg" fluid></b-img>
              </div>
            </div>
          </b-tab>
          <b-tab title="宗旨" v-if="$i18n.locale === 'tw'">
            <p>
1. 促進德育，輔助民間四育之不足。<br>
2. 推展佛慈，發揚積極為善之特色。<br>
3. 闡發倫理，潛移社會淫厲之惡風。<br>
4. 海外宣講，促進國際教界之共識。
            </p>
            <hr>
            <p>
            <h3>推廣事業</h3>
1. 設立圖書館、閱覽室供學生、社會大眾閱覽，並免費借閱經書與佛教錄音影帶、影音光碟等。<br>
2. 贈送佛教圖書、影音光碟及各種教學器材、法寶給國內外佛教團體或文化教育團體。<br>
3. 在佛陀教育宣講方面：<br>
   (1) 長期固定舉辦佛學講座。<br>
   (2) 舉辦各項佛學研討班。<br>
   (3) 舉辦念佛共修會及靜坐班。<br>
4. 提倡佛教文化事業，如中文、英文及各種語文佛學典籍之印贈結緣、中文大藏經及巴利文大藏經之贈予、佛教錄音影帶、CD、VCD、DVD、MP3之贈送結緣等。<br>
5. 辦理放生、護生教育宣導，以改善社會風氣。<br>
6. 捐贈獎助學金，培育佛教僧才。<br>
7. 其他一切有利於社會公益、文化教育事業之推展。
            </p>
            <hr>
            <p>
            <h3>發展目標</h3>
目前基金會於台北縣深坑鄉，正在設立「財團法人佛陀教育基金會　華藏教學園區」，除可提供基金會教學及共修之外，亦可對外免費開放給具正知見之人民團體，來舉辦各種佛教修學及有益身心、增長智慧之活動，例如：佛七、禪七或兒童佛學冬夏令營等。<br>
配合將來「華藏教學園區」的落成啟用，基金會的弘法目標，目前規畫成四個大方向：<br>
1. 印贈經書工作的持續推動。<br>
2. 擴大網際網路佛法資訊服務的提供，尤其在影音方面。<br>
3. 解門方面，佛學課程的總體性規畫。<br>
4. 行門方面，增進大眾參與念佛共修的意願，以及加強禪定靜坐等實修課程。 
            </p>
            <hr>
            <div class="row">
              <div class="col-4">
                <b-img src="img/introduction/03.jpg" fluid></b-img>
              </div>
              <div class="col-4">
                <b-img src="img/introduction/04.jpg" fluid></b-img>
              </div>
              <div class="col-4">
                <b-img src="img/introduction/05.jpg" fluid></b-img>
              </div>
            </div>
          </b-tab>
          <b-tab :title="$t('introduction.detail.current-situation.title')">
<div v-if="$i18n.locale === 'tw'">
            <h3>從印送經書到佛教文化推廣</h3>
            <h4>佛陀教育基金會前執行長　阮貴良</h4>
            <h4>2008年 9月</h4>
　　【摘要】新世紀中的佛教出版文化、印經事業，必須著重在佛教教育文化的推廣，能運用影音設備結合現代高科技，希望能將佛教教育突破地理、時空環境以及語言文字的限制，更普遍廣大流通於全世界及未來。<br>

一、概述<br>
　　隨著時代環境的變遷，佛教印經出版文化事業也有顯著的變化，經書法寶同時面臨新的種類格式與流通方式；本會(佛陀教育基金會) 成立二十多年來，一直從事於佛陀教育文化的推廣，在2000年6月「邁向二十一世紀佛教出版座談會」中，已曾簡介本會之近期概況；但為考慮能讓大眾對本會之出版及教育文化推廣工作，可以有較完整的認識，故在此簡略介紹過去的經書出版與結緣流通情況，再提供本會現前的教育文化推廣經驗來與大眾分享，希望能在新世紀中，與各界佛教團體，共同開創與時俱進的佛教教育文化事業。<br>
二、基金會經書出版、印贈結緣的歷史沿革<br>
(一) 「華藏法施會」之承續<br>
　　本會董事長淨空法師早年在台北成立「華藏法施會」，印贈佛經與大眾結緣，行之多年。1984年，本會發起人簡豐文居士，由於受師父的感召，奉獻自有房地產，成立「華藏講堂」，作為佛教視聽圖書館與弘揚佛法的場所。印贈經書與大眾結緣，同時提供佛教圖書與錄音、影帶予大眾借閱(聽)；講堂則做為大眾閱覽室及邀請法師大德講演佛法經論的講經弘法場所，來弘揚佛陀教育。從那時起，也接受大眾捐贈來印贈佛教經書，如同一般「印經會」所做之佛教事業。此階段印經的內容大都以線裝古書之經論註疏再版為主要方向，以保留寶貴的古版經書，使其有新印製的經書供佛弟子閱讀，及作為將來再版時的重要依據。<br>
(二) 基金會正式登記「出版社」<br>
　　在 1985年1月8日由教育部正式核准成立財團法人基金會；並於11月向新聞局申請成立「雜誌社」，於1987年3月登記成立「出版社」，以正式登記之「雜誌社」與「出版社」來發行月刊及佛教經書，在當時，可說是不同於一般佛教「印經會」的作業方式。<br>
　　本會在各項經費運用上，一貫以「專款專用」為原則；並在每月月刊中，公開財務收支表，以及每筆捐款之詳細功德名單，或許是這種做法得到大眾的認同，故能在最初成立的短短五、六年內，出版經費竟然約成長十倍左右。在當時基金會的經費財務運作上，「出版」的經費漸漸成為主要財務收支；時至今日，此項「印(購) 經書及運費」功德金，仍然約佔本會收入之50%左右。<br>
(三) 出版方向的演變<br>
　　由於本會多年來印製出版的佛書數量太多、種類太廣，僅能以大方向約略分類，以供大眾參考：<br>
1. 初機學佛、基本教理佛書之大量推廣。<br>
2. 印製出版各國文字之佛書經典，以協助世界各地佛教之弘揚。<br>
3. 協助大陸各地佛教團體印贈佛書。<br>
4. 古大德深入教理之註疏重新輸入排版。<br>
5. 中國佛教各宗派重要典籍之重新編排版面格式。<br>
6. 「可攜式文件」製作，提供下載服務。<br>
7. 兒童佛書之編寫出版。<br>
(四) 版面編輯特色<br>
(1) 封面設計：<br>
　　突破傳統佛教經書保守的封面設計風格，希望佛經論疏也能為一般大眾容易接受，在封面設計上儘量與出版新趨勢配合，但不求花俏，尚保存其莊嚴的特質，掃除社會大眾對佛書的刻板印象，藉以提昇佛書的價值感。<br>
(2) 內文編輯：<br>
　　木刻版線裝書中，「經文」、「註解」與「科判」三部分的字體都一樣，本會為擺脫此制式的編排模式，讓三者的字型、段落行距做不同之安排，讀者便可輕易辨別；甚至在「註解」中若有「疏」、「鈔」、「記」的不同，也做不同安排。<br>
(3) 出版書號登錄：<br>
　　為區別及管理所出版的大量中外文佛書，並配合電腦做有系統的資料庫管理或搜尋，很早就開始登錄出版書號。其中，採用「中國佛教圖書分類法」的編碼，做為中文書籍的編號原則，外文書則以國家英文名稱之前二碼配合編號登錄。<br>
(五) 出版印製業務改進：<br>
　　本會最初如同一般「印經會」做法，完全委託一家印刷公司或出版社，全程處理印製業務，所以只能考慮價格是否合理？經書的品質是否滿意？在1994年左右，開始新的作業方式，分別與打字排版、紙商、製版、印刷、裝訂廠商接洽，約節省成本百分三十，要求「出版部」工作人員必須提高對印刷出版的專業知識。「原稿製作」部分，原來是委託電腦排版公司做文字檔輸入與版面編輯、出清樣稿，至1997年起，改由「出版部」自行操作電腦排版作業，至此，可以全面管控完整的出版流程。另有幾點，提供參考：<br>
1. 平裝書：封面之製版印刷，採用多本書拼版方式一起印製，以節省成本及減少紙張浪費；缺點是數量必須整體考量。<br>
2. 貝葉經：藏文貝葉經的製作，在製版印刷上，不採用傳統折本的排列模式，而研究出新的模式，讓一版中能排更多頁數(最多曾經排24頁) 。<br>
3. 電子書： 提供無版權要求、最新編排的經論註疏，以便利大眾翻印流通；同時達到「佛書電子化」，便於提供網際網路下載服務。(目前於網站中所提供下載之經書目錄，如附表一 (請參考「書目總表」) 。<br>
(六) 出版業務特色：<br>
　　近年來印製數量，請見附表(二)<br>
1. 以文教基金會的優勢來印贈經書，確實與一般佛教界出版社不同，在經費來源上，由於得到社會大眾認同與護持，不需考慮商業行銷流通管道，可以依據理想來實行印經計劃及經書結緣。<br>
2. 與一般印經會不同，印製出版多種外文佛書，及從事更多的佛教文化傳播推廣事業。<br>
3. 印經款項分二類運作，「委託代印」與「一般隨喜」二項，前者必須是由發心者出資印製一千本的經費，後者則是隨喜贊助本會印經，列入「印經計劃」項目中，可由本會按計劃安排全年度的出版書目，以<br>達成推廣佛法教育的目標。<br>
(七) 法寶流通特色<br>
(1) 將「印贈經書結緣流通」視為是一種佛教教育的推廣手段、方法，同時也是協助各界佛教文化復興的重要工具。謹此列舉幾項工作：<br>
1. 所有經書完全免費結緣，遍及世界各地。<br>
2. 分「大眾結緣」與「珍藏圖書」兩類：「珍藏圖書」則是提供各地佛學圖書館館藏用書，及各地佛學院或佛教團體佛學課程參考用書。<br>
3. 印贈中文大藏經與大陸佛教及世界各地之寺院、道場、佛教團體結緣：從1985年起，開始海外贈書的活動；1989年則印贈《大正藏》數百套，贈予大陸佛教寺院、道場，及東南亞世界各地佛教團體，廣獲各地好評。1998年起，又印贈《乾隆大藏經》數百套，主要贈送大陸。<br>
4. 協助外文大藏經的印製與流通：「印度天城體巴利文大藏經」(全套140冊，印贈1200套) 、「緬甸巴利文大藏經」(全套40冊，印贈3000套) <br>、「斯里蘭卡巴利文大藏經」(全套57冊，印贈2000套) 、「寮國文巴利藏節要」(全套8冊，印贈3000套) 及「藏文大寶伏藏」(全套76冊，印贈1200套) 。即將印贈「柬埔寨文巴利藏」(全套110冊，印贈2000套) 。<br>
5. 協助蒙古佛教、柬埔寨等國家佛教復興：印贈多種當地文字的佛經書。<br>
6. 協助藏人僧伽教育所需之教材：提供多處在印度的藏人佛學院、寺院，印贈所需的僧伽教育經續法本。<br>
(2) 為使佛教經書法寶能更普遍廣大流通於全世界及未來：<br>
1. 本會完全放棄製版權要求。<br>
2. 若有作者希望於本會出版其作品，則必定要求同意放棄著作權。<br>
3. 希望能配合眾多電腦使用者的方便運用，本會全部使用Microsoft Office 的Word程式來編排佛經書檔案，並同時製作成 PDF 檔，以避免字型使用與造字的困擾。<br>
三、佛教文化推廣<br>
　　古代高僧大德如玄奘、義淨、慧日等大師，不畏生命危苦，不懼千辛萬苦，只為了能將佛法的傳播的更久、更遠，誠令我凡輩後人景仰讚嘆不已。時至今日，已有方便的現代高科技，佛陀教育、佛教文化傳播及推廣，理應不該受地理、時空環境、語言文字的限制，但看吾等佛弟子如何運用現代高科技爾！<br>
1. 講經弘法課程數位化：不再侷限於一時、一地的教學；將課程現場錄製成數位化的影音檔，以利電腦保存及後製，亦可置於網際網路中供下載。<br>
2. 搜集具有正知正見法師的講經說法錄影、錄音檔，包括世界佛教三大系(南傳、漢傳、藏傳) 各宗派法門，將其轉成MP3或RM檔案格式，置於網際網路中供下載。(本會所提供之RM 或MP3檔分類統計表，略如附表三、表四)<br>
3. 未來展望：<br>
現場網路直播：在佛門中達到遠距教學的成效。<br>
3G行動數位之服務：讓佛門訊息能迅速、立即傳達給需要的人，及隨時隨地都能聽經、念佛，實現修行道場行動數位化。<br>
經書館藏數位化：將尚未經電腦排版的佛經書，先掃瞄為圖檔影像，收藏於電腦資料庫系統中，以利資料檢索查詢及文獻保存、流通。<br>
四、結語<br>
　　本會多年來的工作方向，是希望透過經書出版、印贈結緣到現代科技：影音光碟、聲音數位檔(MP3) 、影片數位檔(RM) 、網際網路、3G行動數位服務的結緣流通，達到弘揚廣大佛法的目標，更加顯示出佛法的普遍性及無窮可能性。在此同時，本會亦希望所有的佛教團體或印經會，還有四眾弟子們要來關心、重視：我們對經書法寶的恭敬心與舊書、舊錄音影帶兩者之間的處理問題。當然，這又是另一個很重要但需大家共同來深思、討論的議題。<br>
相關文章：「佛書出版概況之回顧與展望」
</div>
<div v-if="$i18n.locale === 'en'">
<p>As a result of the loving care and devotion of the staff members and volunteers, the seed that was planted in 1982 has continued to grow and flourish, and currently the foundation is able to offer the general public the following services:</p>
<p>1.A well stocked library</p>
<p>2.A lecture hall for Dharma lectures</p>
<p>3.Dharma teachings offered free of charge (including the postal costs) in more than twenty languages available in book, CD, VCD, and cassette formats</p>
<p>4.Photographs of the Buddha</p>
<p>5.Organising regular "releasing life" activities</p>
</div>
          </b-tab>
          <b-tab title="管理辦法" v-if="$i18n.locale === 'tw'">
            <p>
              <a href="https://www2.budaedu.org/official-website-data/introduce/budaedu.pdf">
                捐助章程、組織細則、工作辦法 (PDF 檔案)
              </a>
            </p>
            <p>
              <a href="https://www2.budaedu.org/official-website-data/introduce/hwazanTanLin.doc">
                華藏檀林組織及管理辦法 (Word 檔案)
              </a>
            </p>
            <p>
              <a href="https://www2.budaedu.org/official-website-data/introduce/college.doc">
                假日佛學院組織及管理辦法 (Word 檔案)
              </a>
            </p>
            <p>
              <a href="https://www2.budaedu.org/official-website-data/introduce/hwazan.doc">
                華藏教學園區組織及管理辦法 (Word 檔案)
              </a>
            </p>
            <p>
              <a href="https://www2.budaedu.org/official-website-data/introduce/budaeduWorkrule.doc">
                工作規則 (勞動局核備) (2016/11) (Word 檔案)
              </a>
            </p>
            <p>
              <a href="https://www2.budaedu.org/official-website-data/introduce/2017.7.21.pdf">
                工作場所性騷擾防治措施 申訴及懲戒辦法 (PDF 檔案)
              </a>
            </p>
          </b-tab>
        </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(ImagePlugin)
Vue.use(TabsPlugin)

export default {
  i18n,
  name: 'introduction',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    this.$i18n.locale = this.$localStorage.get('ui-lang', 'tw')
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('introduction.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>